// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 10em;
  padding: 7em;
  background-color: #050505;
  align-items: center;
  justify-content: center;
  z-index: 8;
  position: relative;
  border-top: 1px solid rgba(136, 136, 138, 0.5);
}
.footer_nav-links {
  flex: 1.8 1;
  display: flex;
  flex-direction: row;
  gap: 2em;
}
.footer_nav-links_link {
  display: inline-block;
  font-family: "Varela Round";
  font-size: 0.65em;
  letter-spacing: 5px;
  color: #88888a;
  text-transform: uppercase;
  position: relative;
  height: 2.5em;
  padding: 0.2em;
  transition: all 0.3s ease-in-out;
}
.footer_nav-links_link:hover {
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  border-bottom: 2px solid #ffc917;
  color: #f3f3f3;
}
.footer_copyright {
  font-family: "Varela Round";
  color: #88888a;
  text-align: left;
  padding: 0.4em;
}
.footer_copyright-sm {
  font-family: "Varela Round";
  font-size: 0.8em;
  color: #88888a;
  text-align: left;
}
.footer_logo {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 2 1;
}
.footer_logo > img {
  width: 6em;
  height: 6em;
  cursor: pointer;
}
.footer_social {
  display: flex;
  flex-direction: row;
  flex: 2 1;
  margin-top: 1em;
  align-items: center;
  gap: 2em;
}

@keyframes blurry {
  0% {
    filter: blur(100px);
  }
  100% {
    filter: blur(0px);
  }
}
@keyframes flickerL {
  0% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  22.22222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  24% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  24.02222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  25.8% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  25.82222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  27.6% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  27.62222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  29.4% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  100% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
}
@keyframes flickerO {
  0% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  22.22222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  24% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  24.02222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  25.8% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  25.82222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  27.6% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  27.62222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  29.4% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  72.66667% {
    color: rgba(255, 255, 255, 0.7);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 400px white, 0 0 100px white, 0 0 80px white, 0 0 40px white;
  }
  73.33333% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  74% {
    color: rgba(255, 255, 255, 0.7);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 400px white, 0 0 100px white, 0 0 80px white, 0 0 40px white;
  }
  74.66667% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  75.33333% {
    color: rgba(255, 255, 255, 0.7);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 400px white, 0 0 100px white, 0 0 80px white, 0 0 40px white;
  }
  75.77778% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  94.44444% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  100% {
    color: black;
    -webkit-text-stroke-color: rgb(240, 0, 0);
    text-shadow: none;
  }
}
@keyframes flickerA {
  0% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  22.22222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  24% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  24.02222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  25.8% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  25.82222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  27.6% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  27.62222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  29.4% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  88.86667% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  88.88889% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  100% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
}
@keyframes flickerD {
  0% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  22.22222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  24% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  24.02222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  25.8% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  25.82222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  27.6% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  27.62222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  29.4% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  83.31111% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  83.33333% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  100% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
}
@keyframes flickerI {
  0% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  22.22222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  24% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  24.02222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  25.8% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  25.82222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  27.6% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  27.62222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  29.4% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  77.75556% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  77.77778% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  100% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
}
@keyframes flickerN {
  0% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  22.22222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  24% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  24.02222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  25.8% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  25.82222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  27.6% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  27.62222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  29.4% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  72.2% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  72.22222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  100% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
}
@keyframes flickerG {
  0% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  22.22222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  24% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  24.02222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  25.8% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  25.82222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  27.6% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  27.62222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  29.4% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  66.64444% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  66.66667% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  100% {
    color: black;
    -webkit-text-stroke-color: rgb(240, 0, 0);
    text-shadow: none;
  }
}
#f {
  position: absolute;
  bottom: 8%;
  left: -18%;
  right: 0;
  height: 5vw;
  width: 20%;
  transform: translateY(-50%);
  margin: 0 auto;
  text-align: center;
  z-index: 8;
}

#f li {
  display: inline-block;
  position: relative;
  height: 5vw;
  list-style: none;
  font-family: "Varela Round";
  font-weight: bolder;
  font-size: 1.5vw;
  color: black;
  -webkit-text-stroke-width: 0.045vw;
  -webkit-text-stroke-color: rgb(240, 0, 0);
  animation-iteration-count: infinite;
  animation-fill-mode: forwards;
}

#f li:nth-child(1) {
  animation-name: flickerL;
  animation-delay: 0s;
  animation-duration: 4.5s;
}

#f li:nth-child(2) {
  animation-name: flickerO;
  animation-delay: 0.25s;
  animation-duration: 4.5s;
}

#f li:nth-child(3) {
  animation-name: flickerA;
  animation-delay: 0.5s;
  animation-duration: 4.5s;
}

#f li:nth-child(4) {
  animation-name: flickerD;
  animation-delay: 0.75s;
  animation-duration: 4.5s;
}

#f li:nth-child(5) {
  animation-name: flickerI;
  animation-delay: 1s;
  animation-duration: 4.5s;
}

#f li:nth-child(6) {
  animation-name: flickerN;
  animation-delay: 1.25s;
  animation-duration: 4.5s;
}

#f li:nth-child(7) {
  animation-name: flickerG;
  animation-delay: 1.5s;
  animation-duration: 4.5s;
}

#o {
  position: absolute;
  bottom: 8%;
  left: 11%;
  right: 0%;
  height: 5vw;
  width: 20%;
  transform: translateY(-50%);
  margin: 0 auto;
  text-align: center;
  z-index: 8;
}

#o li {
  display: inline-block;
  position: relative;
  height: 5vw;
  list-style: none;
  font-family: "Varela Round";
  font-weight: bolder;
  font-size: 1.5vw;
  color: black;
  -webkit-text-stroke-width: 0.045vw;
  -webkit-text-stroke-color: rgb(240, 0, 0);
  animation-iteration-count: infinite;
  animation-fill-mode: forwards;
}

#o li:nth-child(1) {
  animation-name: flickerL;
  animation-delay: 0s;
  animation-duration: 4.5s;
}

#o li:nth-child(2) {
  animation-name: flickerO;
  animation-delay: 0.25s;
  animation-duration: 4.5s;
}

#o li:nth-child(3) {
  animation-name: flickerA;
  animation-delay: 0.5s;
  animation-duration: 4.5s;
}

#o li:nth-child(4) {
  animation-name: flickerD;
  animation-delay: 0.75s;
  animation-duration: 4.5s;
}

#o li:nth-child(5) {
  animation-name: flickerI;
  animation-delay: 1s;
  animation-duration: 4.5s;
}

/* button styling */
.button {
  margin: 0;
  background: transparent;
  padding: 0;
  border: none;
  cursor: pointer;
}

.button {
  --border-right: 6px;
  --text-stroke-color: rgba(255, 255, 255, 0.6);
  --animation-color: #37ff8b;
  --fs-size: 1em;
  letter-spacing: 3px;
  text-decoration: none;
  font-size: var(--fs-size);
  font-family: "Arial";
  position: relative;
  text-transform: uppercase;
  color: transparent;
  -webkit-text-stroke: 1px var(--text-stroke-color);
}
@media screen and (max-width: 1280px) {
  .button {
    --fs-size: 1em;
  }
}
@media screen and (max-width: 600px) {
  .button {
    --fs-size: 0.8em;
  }
}

/* this is the text, when you hover on button */
.hover-text {
  position: absolute;
  box-sizing: border-box;
  content: attr(data-text);
  color: var(--animation-color);
  width: 0%;
  inset: 0;
  border-right: var(--border-right) solid var(--animation-color);
  overflow: hidden;
  transition: 0.5s;
  -webkit-text-stroke: 1px var(--animation-color);
}

/* hover */
.button:hover .hover-text {
  width: 100%;
  filter: drop-shadow(0 0 23px var(--animation-color));
}

.instaBtn {
  width: 45px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background-color: transparent;
  position: relative;
  /* overflow: hidden; */
  border-radius: 7px;
  cursor: pointer;
  transition: all 0.3s;
}

.svgContainer {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  -webkit-backdrop-filter: blur(4px);
          backdrop-filter: blur(4px);
  letter-spacing: 0.8px;
  border-radius: 10px;
  transition: all 0.3s;
  border: 1px solid rgba(156, 156, 156, 0.466);
}

.BG {
  position: absolute;
  content: "";
  width: 100%;
  height: 100%;
  background: #f09433;
  background: linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="#f09433", endColorstr="#bc1888",GradientType=1 );
  z-index: -1;
  border-radius: 9px;
  pointer-events: none;
  transition: all 0.3s;
}

.instaBtn:hover .BG {
  transform: rotate(35deg);
  transform-origin: bottom;
}

.instaBtn:hover .svgContainer {
  background-color: rgba(156, 156, 156, 0.466);
}

.faceBtn {
  width: 45px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background-color: transparent;
  position: relative;
  /* overflow: hidden; */
  border-radius: 7px;
  cursor: pointer;
  transition: all 0.3s;
}

.faceContainer {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  -webkit-backdrop-filter: blur(0px);
          backdrop-filter: blur(0px);
  letter-spacing: 0.8px;
  border-radius: 10px;
  transition: all 0.3s;
  border: 1px solid rgba(156, 156, 156, 0.466);
}

.faceBG {
  position: absolute;
  content: "";
  width: 100%;
  height: 100%;
  background: #1877f2;
  z-index: -1;
  border-radius: 10px;
  pointer-events: none;
  transition: all 0.3s;
}

.faceBtn:hover .faceBG {
  transform: rotate(35deg);
  transform-origin: bottom;
}

.faceBtn:hover .faceContainer {
  border: 1px solid rgba(230, 230, 230, 0.466);
  background-color: rgba(204, 204, 204, 0.466);
  -webkit-backdrop-filter: blur(4px);
          backdrop-filter: blur(4px);
}

.linkedBtn {
  width: 45px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background-color: transparent;
  position: relative;
  /* overflow: hidden; */
  border-radius: 7px;
  cursor: pointer;
  transition: all 0.3s;
}

.linkedContainer {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  -webkit-backdrop-filter: blur(0px);
          backdrop-filter: blur(0px);
  letter-spacing: 0.8px;
  border-radius: 10px;
  transition: all 0.3s;
  border: 1px solid rgba(156, 156, 156, 0.466);
}

.linkedBG {
  position: absolute;
  content: "";
  width: 100%;
  height: 100%;
  background: white;
  z-index: -1;
  border-radius: 10px;
  pointer-events: none;
  transition: all 0.3s;
}

.linkedBtn:hover .linkedBG {
  transform: rotate(35deg);
  transform-origin: bottom;
}

.linkedBtn:hover .linkedContainer {
  border: 1px solid rgba(230, 230, 230, 0.466);
  background-color: rgba(204, 204, 204, 0.466);
  -webkit-backdrop-filter: blur(4px);
          backdrop-filter: blur(4px);
}

@media (min-width: 390px) {
  .footer {
    height: 20em;
    padding: 0;
  }
  .footer_logo {
    flex: 3 1;
  }
  .footer_nav-links {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    gap: 2em;
    text-align: center;
  }
}
@media (min-width: 768px) {
  .footer {
    align-items: baseline;
  }
}
@media (min-width: 1024px) {
  .footer {
    height: 10em;
    padding: 7em;
    align-items: center;
  }
  .footer_logo {
    flex: 2 1;
  }
  .footer_nav-links {
    display: flex;
    flex-direction: row;
    gap: 2em;
    flex-wrap: nowrap;
  }
  #f, #o {
    bottom: 20%;
  }
}
@media (min-width: 1280px) {
  .footer {
    height: 10em;
    padding: 7em;
    align-items: center;
  }
  .footer_logo {
    flex: 2 1;
  }
  .footer_nav-links {
    display: flex;
    flex-direction: row;
    gap: 2em;
    flex-wrap: nowrap;
  }
  #f, #o {
    bottom: 8%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/footer/styles.scss","webpack://./src/assets/scss/components/_colors.scss","webpack://./src/assets/scss/components/_mixins.scss"],"names":[],"mappings":"AAGA;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,yBCLQ;EDMR,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,kBAAA;EACA,8CAAA;AAFJ;AAII;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAFR;AAIQ;EACI,qBAAA;EACA,2BAAA;EACA,iBAAA;EACA,mBAAA;EACA,cCtBD;EDuBC,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;EACA,gCAAA;AAFZ;AAIY;EACI,eAAA;EACA,gCAAA;EACA,gCAAA;EACA,cChCJ;AD8BZ;AAOI;EACI,2BAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;AALR;AASI;EACE,2BAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAPN;AAWI;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AATR;AAWQ;EACI,UAAA;EACA,WAAA;EACA,eAAA;AATZ;AAiBI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,mBAAA;EAEA,QAAA;AAhBR;;AAuBA;EACI;IACE,mBAAA;EApBJ;EAuBE;IACE,iBAAA;EArBJ;AACF;AAwBE;EACE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAtBJ;EAyBE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAvBJ;EAyBE;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAvBJ;EAyBE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAvBJ;EAyBE;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAvBJ;EAyBE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAvBJ;EAyBE;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAvBJ;EAyBE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAvBJ;EAyBE;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAvBJ;EAyBE;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAvBJ;AACF;AA0BE;EACE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAxBJ;EA2BE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAzBJ;EA2BE;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAzBJ;EA2BE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAzBJ;EA2BE;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAzBJ;EA2BE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAzBJ;EA2BE;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAzBJ;EA2BE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAzBJ;EA2BE;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAzBJ;EA2BE;IACE,+BAAA;IACA,gCAAA;IACA,6EAAA;EAzBJ;EA4BE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA1BJ;EA4BE;IACE,+BAAA;IACA,gCAAA;IACA,6EAAA;EA1BJ;EA6BE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA3BJ;EA6BE;IACE,+BAAA;IACA,gCAAA;IACA,6EAAA;EA3BJ;EA8BE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA5BJ;EA8BE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA5BJ;EA8BE;IACE,YAAA;IACA,yCAAA;IACA,iBAAA;EA5BJ;AACF;AA+BE;EACE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA7BJ;EAgCE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA9BJ;EAgCE;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EA9BJ;EAgCE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA9BJ;EAgCE;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EA9BJ;EAgCE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA9BJ;EAgCE;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EA9BJ;EAgCE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA9BJ;EAgCE;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EA9BJ;EAgCE;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EA9BJ;EAgCE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA9BJ;EAgCE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA9BJ;AACF;AAiCE;EACE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA/BJ;EAkCE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAhCJ;EAkCE;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAhCJ;EAkCE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAhCJ;EAkCE;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAhCJ;EAkCE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAhCJ;EAkCE;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAhCJ;EAkCE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAhCJ;EAkCE;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAhCJ;EAkCE;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAhCJ;EAkCE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAhCJ;EAkCE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAhCJ;AACF;AAmCE;EACE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAjCJ;EAoCE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAlCJ;EAoCE;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAlCJ;EAoCE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAlCJ;EAoCE;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAlCJ;EAoCE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAlCJ;EAoCE;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAlCJ;EAoCE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAlCJ;EAoCE;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAlCJ;EAoCE;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAlCJ;EAoCE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAlCJ;EAoCE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAlCJ;AACF;AAqCE;EACE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAnCJ;EAsCE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EApCJ;EAsCE;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EApCJ;EAsCE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EApCJ;EAsCE;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EApCJ;EAsCE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EApCJ;EAsCE;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EApCJ;EAsCE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EApCJ;EAsCE;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EApCJ;EAsCE;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EApCJ;EAsCE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EApCJ;EAsCE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EApCJ;AACF;AAuCE;EACE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EArCJ;EAwCE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAtCJ;EAwCE;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAtCJ;EAwCE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAtCJ;EAwCE;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAtCJ;EAwCE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAtCJ;EAwCE;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAtCJ;EAwCE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAtCJ;EAwCE;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAtCJ;EAwCE;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAtCJ;EAwCE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAtCJ;EAwCE;IACE,YAAA;IACA,yCAAA;IACA,iBAAA;EAtCJ;AACF;AA0CE;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;EACA,2BAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;AAxCJ;;AA0CE;EACE,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,2BAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,kCAAA;EACA,yCAAA;EACA,mCAAA;EACA,6BAAA;AAvCJ;;AAyCE;EACE,wBAAA;EACA,mBAAA;EACA,wBAAA;AAtCJ;;AAwCE;EACE,wBAAA;EACA,sBAAA;EACA,wBAAA;AArCJ;;AAuCE;EACE,wBAAA;EACA,qBAAA;EACA,wBAAA;AApCJ;;AAsCE;EACE,wBAAA;EACA,sBAAA;EACA,wBAAA;AAnCJ;;AAqCE;EACE,wBAAA;EACA,mBAAA;EACA,wBAAA;AAlCJ;;AAoCE;EACE,wBAAA;EACA,sBAAA;EACA,wBAAA;AAjCJ;;AAmCE;EACE,wBAAA;EACA,qBAAA;EACA,wBAAA;AAhCJ;;AAmCE;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,2BAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;AAhCJ;;AAkCE;EACE,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,2BAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,kCAAA;EACA,yCAAA;EACA,mCAAA;EACA,6BAAA;AA/BJ;;AAiCE;EACE,wBAAA;EACA,mBAAA;EACA,wBAAA;AA9BJ;;AAgCE;EACE,wBAAA;EACA,sBAAA;EACA,wBAAA;AA7BJ;;AA+BE;EACE,wBAAA;EACA,qBAAA;EACA,wBAAA;AA5BJ;;AA8BE;EACE,wBAAA;EACA,sBAAA;EACA,wBAAA;AA3BJ;;AA6BE;EACE,wBAAA;EACA,mBAAA;EACA,wBAAA;AA1BJ;;AAiCA,mBAAA;AACA;EACI,SAAA;EACA,uBAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;AA9BJ;;AAgCE;EACE,mBAAA;EACA,6CAAA;EACA,0BAAA;EACA,cAAA;EACA,mBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iDAAA;AA7BJ;AA+BI;EAdF;IAeI,cAAA;EA5BJ;AACF;AA8BI;EAlBF;IAmBI,gBAAA;EA3BJ;AACF;;AA6BE,+CAAA;AACA;EACE,kBAAA;EACA,sBAAA;EACA,wBAAA;EACA,6BAAA;EACA,SAAA;EACA,QAAA;EACA,8DAAA;EACA,gBAAA;EACA,gBAAA;EACA,+CAAA;AA1BJ;;AA4BE,UAAA;AACA;EACE,WAAA;EACA,oDAAA;AAzBJ;;AA8BE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,6BAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;AA3BJ;;AA8BE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;EACA,kCAAA;UAAA,0BAAA;EACA,qBAAA;EACA,mBAAA;EACA,oBAAA;EACA,4CAAA;AA3BJ;;AA8BE;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EAGA,mGAAA;EACA,mHAAA;EACA,WAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;AA3BJ;;AA8BE;EACE,wBAAA;EACA,wBAAA;AA3BJ;;AA8BE;EACE,4CAAA;AA3BJ;;AA8BE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,6BAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;AA3BJ;;AA8BE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;EACA,kCAAA;UAAA,0BAAA;EACA,qBAAA;EACA,mBAAA;EACA,oBAAA;EACA,4CAAA;AA3BJ;;AA8BE;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;AA3BJ;;AA8BE;EACE,wBAAA;EACA,wBAAA;AA3BJ;;AA8BE;EACE,4CAAA;EACA,4CAAA;EACA,kCAAA;UAAA,0BAAA;AA3BJ;;AA+BE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,6BAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;AA5BJ;;AA+BE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;EACA,kCAAA;UAAA,0BAAA;EACA,qBAAA;EACA,mBAAA;EACA,oBAAA;EACA,4CAAA;AA5BJ;;AA+BE;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;AA5BJ;;AA+BE;EACE,wBAAA;EACA,wBAAA;AA5BJ;;AA+BE;EACE,4CAAA;EACA,4CAAA;EACA,kCAAA;UAAA,0BAAA;AA5BJ;;AEz1BE;EF03BE;IACE,YAAA;IACA,UAAA;EA7BJ;EA+BI;IACE,SAAA;EA7BN;EAiCE;IACE,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,mBAAA;IACA,eAAA;IACA,QAAA;IACA,kBAAA;EA/BJ;AACF;AEt2BE;EFy4BE;IACE,qBAAA;EAhCJ;AACF;AEr2BE;EFy4BE;IACE,YAAA;IACA,YAAA;IACA,mBAAA;EAjCJ;EAmCI;IACE,SAAA;EAjCN;EAqCE;IACE,aAAA;IACA,mBAAA;IACA,QAAA;IACA,iBAAA;EAnCJ;EAsCE;IACE,WAAA;EApCJ;AACF;AEl3BE;EF05BE;IACE,YAAA;IACA,YAAA;IACA,mBAAA;EArCJ;EAuCI;IACE,SAAA;EArCN;EAyCE;IACE,aAAA;IACA,mBAAA;IACA,QAAA;IACA,iBAAA;EAvCJ;EA0CE;IACE,UAAA;EAxCJ;AACF","sourcesContent":["@import \"../../assets/scss/combined.scss\";\n\n\n.footer {\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n    height: 10em;\n    padding: 7em;\n    background-color: $bdt-black;\n    align-items: center;\n    justify-content: center;\n    z-index: 8;\n    position: relative;\n    border-top: 1px solid rgba(136, 136, 138, 0.5);\n\n    &_nav-links {\n        flex: 1.8;\n        display: flex;\n        flex-direction: row;\n        gap: 2em;\n\n        &_link {\n            display: inline-block;\n            font-family: \"Varela Round\";\n            font-size: .65em;\n            letter-spacing: 5px;\n            color: $bdt-gray;\n            text-transform: uppercase;\n            position: relative;\n            height: 2.5em;\n            padding: .2em;\n            transition: all .3s ease-in-out;\n\n            &:hover {\n                cursor: pointer;\n                transition: all .3s ease-in-out;\n                border-bottom: 2px solid $bdt-gold;\n                color: $bdt-white;\n            }\n        }\n    }\n\n    &_copyright {\n        font-family: \"Varela Round\";\n        color: #88888a;\n        text-align: left;\n        padding: .4em;\n        // margin-top: 2em;\n    }\n\n    &_copyright-sm {\n      font-family: \"Varela Round\";\n      font-size: .8em;\n      color: #88888a;\n      text-align: left;\n      // margin-top: 2em;\n  }\n\n    &_logo {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        flex: 2;\n\n        & > img {\n            width: 6em;\n            height: 6em;\n            cursor: pointer;\n        }\n    }\n\n    &_name {\n     \n    }\n\n    &_social {\n        display: flex;\n        flex-direction: row;\n        flex: 2;\n        margin-top: 1em;\n        align-items: center;\n        // justify-content: center;\n        gap: 2em;\n        // background-color: orange;\n        // width: 33%;\n    }\n}             \n                \n\n@keyframes blurry {\n    0% {\n      filter: blur(100px);\n    }\n  \n    100% {\n      filter: blur(0px);\n    }\n  }\n  \n  @keyframes flickerL {\n    0% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n      // opacity: 0;\n    }\n    22.22222% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    24% {\n      color: rgba(255, 255, 255, 0.26);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 80px white, 0 0 40px white;\n    }\n    24.02222% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    25.8% {\n      color: rgba(255, 255, 255, 0.26);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 80px white, 0 0 40px white;\n    }\n    25.82222% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    27.6% {\n      color: rgba(255, 255, 255, 0.26);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 80px white, 0 0 40px white;\n    }\n    27.62222% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    29.4% {\n      color: rgba(255, 255, 255, 0.26);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 80px white, 0 0 40px white;\n    }\n    100% {\n      color: rgba(255, 255, 255, 0.26);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 80px white, 0 0 40px white;\n      // opacity: 1;\n    }\n  }\n  @keyframes flickerO {\n    0% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n      // opacity: 0;\n    }\n    22.22222% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    24% {\n      color: rgba(255, 255, 255, 0.26);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 80px white, 0 0 40px white;\n    }\n    24.02222% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    25.8% {\n      color: rgba(255, 255, 255, 0.26);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 80px white, 0 0 40px white;\n    }\n    25.82222% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    27.6% {\n      color: rgba(255, 255, 255, 0.26);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 80px white, 0 0 40px white;\n    }\n    27.62222% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    29.4% {\n      color: rgba(255, 255, 255, 0.26);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 80px white, 0 0 40px white;\n    }\n    72.66667% {\n      color: rgba(255, 255, 255, 0.7);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 400px white, 0 0 100px white, 0 0 80px white,\n        0 0 40px white;\n    }\n    73.33333% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    74% {\n      color: rgba(255, 255, 255, 0.7);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 400px white, 0 0 100px white, 0 0 80px white,\n        0 0 40px white;\n    }\n    74.66667% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    75.33333% {\n      color: rgba(255, 255, 255, 0.7);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 400px white, 0 0 100px white, 0 0 80px white,\n        0 0 40px white;\n    }\n    75.77778% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    94.44444% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    100% {\n      color: black;\n      -webkit-text-stroke-color: rgba(240, 0, 0, 1);\n      text-shadow: none;\n      // opacity: 1;\n    }\n  }\n  @keyframes flickerA {\n    0% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n      // opacity: 0;\n    }\n    22.22222% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    24% {\n      color: rgba(255, 255, 255, 0.26);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 80px white, 0 0 40px white;\n    }\n    24.02222% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    25.8% {\n      color: rgba(255, 255, 255, 0.26);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 80px white, 0 0 40px white;\n    }\n    25.82222% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    27.6% {\n      color: rgba(255, 255, 255, 0.26);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 80px white, 0 0 40px white;\n    }\n    27.62222% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    29.4% {\n      color: rgba(255, 255, 255, 0.26);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 80px white, 0 0 40px white;\n    }\n    88.86667% {\n      color: rgba(255, 255, 255, 0.26);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 80px white, 0 0 40px white;\n    }\n    88.88889% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    100% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n      // opacity: 1;\n    }\n  }\n  @keyframes flickerD {\n    0% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n      // opacity: 0;\n    }\n    22.22222% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    24% {\n      color: rgba(255, 255, 255, 0.26);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 80px white, 0 0 40px white;\n    }\n    24.02222% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    25.8% {\n      color: rgba(255, 255, 255, 0.26);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 80px white, 0 0 40px white;\n    }\n    25.82222% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    27.6% {\n      color: rgba(255, 255, 255, 0.26);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 80px white, 0 0 40px white;\n    }\n    27.62222% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    29.4% {\n      color: rgba(255, 255, 255, 0.26);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 80px white, 0 0 40px white;\n    }\n    83.31111% {\n      color: rgba(255, 255, 255, 0.26);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 80px white, 0 0 40px white;\n    }\n    83.33333% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    100% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n      // opacity: 1;\n    }\n  }\n  @keyframes flickerI {\n    0% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n      // opacity: 0;\n    }\n    22.22222% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    24% {\n      color: rgba(255, 255, 255, 0.26);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 80px white, 0 0 40px white;\n    }\n    24.02222% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    25.8% {\n      color: rgba(255, 255, 255, 0.26);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 80px white, 0 0 40px white;\n    }\n    25.82222% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    27.6% {\n      color: rgba(255, 255, 255, 0.26);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 80px white, 0 0 40px white;\n    }\n    27.62222% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    29.4% {\n      color: rgba(255, 255, 255, 0.26);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 80px white, 0 0 40px white;\n    }\n    77.75556% {\n      color: rgba(255, 255, 255, 0.26);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 80px white, 0 0 40px white;\n    }\n    77.77778% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    100% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n      // opacity: 1;\n    }\n  }\n  @keyframes flickerN {\n    0% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n      // opacity: 0;\n    }\n    22.22222% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    24% {\n      color: rgba(255, 255, 255, 0.26);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 80px white, 0 0 40px white;\n    }\n    24.02222% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    25.8% {\n      color: rgba(255, 255, 255, 0.26);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 80px white, 0 0 40px white;\n    }\n    25.82222% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    27.6% {\n      color: rgba(255, 255, 255, 0.26);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 80px white, 0 0 40px white;\n    }\n    27.62222% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    29.4% {\n      color: rgba(255, 255, 255, 0.26);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 80px white, 0 0 40px white;\n    }\n    72.2% {\n      color: rgba(255, 255, 255, 0.26);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 80px white, 0 0 40px white;\n    }\n    72.22222% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    100% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n      // opacity: 1;\n    }\n  }\n  @keyframes flickerG {\n    0% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n      // opacity: 0;\n    }\n    22.22222% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    24% {\n      color: rgba(255, 255, 255, 0.26);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 80px white, 0 0 40px white;\n    }\n    24.02222% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    25.8% {\n      color: rgba(255, 255, 255, 0.26);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 80px white, 0 0 40px white;\n    }\n    25.82222% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    27.6% {\n      color: rgba(255, 255, 255, 0.26);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 80px white, 0 0 40px white;\n    }\n    27.62222% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    29.4% {\n      color: rgba(255, 255, 255, 0.26);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 80px white, 0 0 40px white;\n    }\n    66.64444% {\n      color: rgba(255, 255, 255, 0.26);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 80px white, 0 0 40px white;\n    }\n    66.66667% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    100% {\n      color: black;\n      -webkit-text-stroke-color: rgba(240, 0, 0, 1);\n      text-shadow: none;\n      // opacity: 1;\n    }\n  }\n  \n  #f {\n    position: absolute;\n    bottom: 8%;\n    left: -18%;\n    right: 0;\n    height: 5vw;\n    width: 20%;\n    transform: translateY(-50%);\n    margin: 0 auto;\n    text-align: center;\n    z-index: 8;\n  }\n  #f li {\n    display: inline-block;\n    position: relative;\n    height: 5vw;\n    list-style: none;\n    font-family: \"Varela Round\";\n    font-weight: bolder;\n    font-size: 1.5vw;\n    color: black;\n    -webkit-text-stroke-width: 0.045vw;\n    -webkit-text-stroke-color: rgba(240, 0, 0, 1);\n    animation-iteration-count: infinite;\n    animation-fill-mode: forwards;\n  }\n  #f li:nth-child(1) {\n    animation-name: flickerL;\n    animation-delay: 0s;\n    animation-duration: 4.5s;\n  }\n  #f li:nth-child(2) {\n    animation-name: flickerO;\n    animation-delay: 0.25s;\n    animation-duration: 4.5s;\n  }\n  #f li:nth-child(3) {\n    animation-name: flickerA;\n    animation-delay: 0.5s;\n    animation-duration: 4.5s;\n  }\n  #f li:nth-child(4) {\n    animation-name: flickerD;\n    animation-delay: 0.75s;\n    animation-duration: 4.5s;\n  }\n  #f li:nth-child(5) {\n    animation-name: flickerI;\n    animation-delay: 1s;\n    animation-duration: 4.5s;\n  }\n  #f li:nth-child(6) {\n    animation-name: flickerN;\n    animation-delay: 1.25s;\n    animation-duration: 4.5s;\n  }\n  #f li:nth-child(7) {\n    animation-name: flickerG;\n    animation-delay: 1.5s;\n    animation-duration: 4.5s;\n  }\n  \n  #o {\n    position: absolute;\n    bottom: 8%;\n    left: 11%;\n    right: 0%;\n    height: 5vw;\n    width: 20%;\n    transform: translateY(-50%);\n    margin: 0 auto;\n    text-align: center;\n    z-index: 8;\n  }\n  #o li {\n    display: inline-block;\n    position: relative;\n    height: 5vw;\n    list-style: none;\n    font-family: \"Varela Round\";\n    font-weight: bolder;\n    font-size: 1.5vw;\n    color: black;\n    -webkit-text-stroke-width: 0.045vw;\n    -webkit-text-stroke-color: rgba(240, 0, 0, 1);\n    animation-iteration-count: infinite;\n    animation-fill-mode: forwards;\n  }\n  #o li:nth-child(1) {\n    animation-name: flickerL;\n    animation-delay: 0s;\n    animation-duration: 4.5s;\n  }\n  #o li:nth-child(2) {\n    animation-name: flickerO;\n    animation-delay: 0.25s;\n    animation-duration: 4.5s;\n  }\n  #o li:nth-child(3) {\n    animation-name: flickerA;\n    animation-delay: 0.5s;\n    animation-duration: 4.5s;\n  }\n  #o li:nth-child(4) {\n    animation-name: flickerD;\n    animation-delay: 0.75s;\n    animation-duration: 4.5s;\n  }\n  #o li:nth-child(5) {\n    animation-name: flickerI;\n    animation-delay: 1s;\n    animation-duration: 4.5s;\n  }\n\n\n\n\n\n/* button styling */\n.button {\n    margin: 0;\n    background: transparent;\n    padding: 0;\n    border: none;\n    cursor: pointer;\n  }\n  .button {\n    --border-right: 6px;\n    --text-stroke-color: rgba(255, 255, 255, 0.6);\n    --animation-color: #37ff8b;\n    --fs-size: 1em;\n    letter-spacing: 3px;\n    text-decoration: none;\n    font-size: var(--fs-size);\n    font-family: 'Arial';\n    position: relative;\n    text-transform: uppercase;\n    color: transparent;\n    -webkit-text-stroke: 1px var(--text-stroke-color);\n  \n    @media screen and (max-width: '1280px') {\n      --fs-size: 1em;\n    }\n  \n    @media screen and (max-width: '600px') {\n      --fs-size: 0.8em;\n    }\n  }\n  /* this is the text, when you hover on button */\n  .hover-text {\n    position: absolute;\n    box-sizing: border-box;\n    content: attr(data-text);\n    color: var(--animation-color);\n    width: 0%;\n    inset: 0;\n    border-right: var(--border-right) solid var(--animation-color);\n    overflow: hidden;\n    transition: 0.5s;\n    -webkit-text-stroke: 1px var(--animation-color);\n  }\n  /* hover */\n  .button:hover .hover-text {\n    width: 100%;\n    filter: drop-shadow(0 0 23px var(--animation-color));\n  }\n  \n  \n  \n  .instaBtn {\n    width: 45px;\n    height: 45px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: none;\n    background-color: transparent;\n    position: relative;\n    /* overflow: hidden; */\n    border-radius: 7px;\n    cursor: pointer;\n    transition: all .3s;\n  }\n  \n  .svgContainer {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: transparent;\n    backdrop-filter: blur(4px);\n    letter-spacing: 0.8px;\n    border-radius: 10px;\n    transition: all .3s;\n    border: 1px solid rgba(156, 156, 156, 0.466);\n  }\n  \n  .BG {\n    position: absolute;\n    content: \"\";\n    width: 100%;\n    height: 100%;\n    background: #f09433;\n    background: -moz-linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%);\n    background: -webkit-linear-gradient(45deg, #f09433 0%,#e6683c 25%,#dc2743 50%,#cc2366 75%,#bc1888 100%);\n    background: linear-gradient(45deg, #f09433 0%,#e6683c 25%,#dc2743 50%,#cc2366 75%,#bc1888 100%);\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f09433', endColorstr='#bc1888',GradientType=1 );\n    z-index: -1;\n    border-radius: 9px;\n    pointer-events: none;\n    transition: all .3s;\n  }\n  \n  .instaBtn:hover .BG {\n    transform: rotate(35deg);\n    transform-origin: bottom;\n  }\n  \n  .instaBtn:hover .svgContainer {\n    background-color: rgba(156, 156, 156, 0.466);\n  }\n  \n  .faceBtn {\n    width: 45px;\n    height: 45px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: none;\n    background-color: transparent;\n    position: relative;\n    /* overflow: hidden; */\n    border-radius: 7px;\n    cursor: pointer;\n    transition: all 0.3s;\n  }\n  \n  .faceContainer {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: transparent;\n    backdrop-filter: blur(0px);\n    letter-spacing: 0.8px;\n    border-radius: 10px;\n    transition: all 0.3s;\n    border: 1px solid rgba(156, 156, 156, 0.466);\n  }\n  \n  .faceBG {\n    position: absolute;\n    content: \"\";\n    width: 100%;\n    height: 100%;\n    background: #1877f2;\n    z-index: -1;\n    border-radius: 10px;\n    pointer-events: none;\n    transition: all 0.3s;\n  }\n  \n  .faceBtn:hover .faceBG {\n    transform: rotate(35deg);\n    transform-origin: bottom;\n  }\n  \n  .faceBtn:hover .faceContainer {\n    border: 1px solid rgba(230, 230, 230, 0.466);\n    background-color: rgba(204, 204, 204, 0.466);\n    backdrop-filter: blur(4px);\n  }\n  \n  \n  .linkedBtn {\n    width: 45px;\n    height: 45px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: none;\n    background-color: transparent;\n    position: relative;\n    /* overflow: hidden; */\n    border-radius: 7px;\n    cursor: pointer;\n    transition: all 0.3s;\n  }\n  \n  .linkedContainer {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: transparent;\n    backdrop-filter: blur(0px);\n    letter-spacing: 0.8px;\n    border-radius: 10px;\n    transition: all 0.3s;\n    border: 1px solid rgba(156, 156, 156, 0.466);\n  }\n  \n  .linkedBG {\n    position: absolute;\n    content: \"\";\n    width: 100%;\n    height: 100%;\n    background: white;\n    z-index: -1;\n    border-radius: 10px;\n    pointer-events: none;\n    transition: all 0.3s;\n  }\n  \n  .linkedBtn:hover .linkedBG {\n    transform: rotate(35deg);\n    transform-origin: bottom;\n  }\n  \n  .linkedBtn:hover .linkedContainer {\n    border: 1px solid rgba(230, 230, 230, 0.466);\n    background-color: rgba(204, 204, 204, 0.466);\n    backdrop-filter: blur(4px);\n  }\n  \n\n  @include screen-sm {\n    .footer {\n      height: 20em;\n      padding: 0;\n\n      &_logo {\n        flex: 3;\n      }\n    }\n\n    .footer_nav-links {\n      display: flex;\n      flex-direction: row;\n      justify-content: center;\n      align-items: center;\n      flex-wrap: wrap;\n      gap: 2em;\n      text-align: center;\n    }\n  }\n\n  @include screen-md {\n    .footer {\n      align-items: baseline;\n    }\n  }\n\n  @include screen-lg {\n    .footer {\n      height: 10em;\n      padding: 7em;\n      align-items: center;\n\n      &_logo {\n        flex: 2;\n      }\n    }\n\n    .footer_nav-links {\n      display: flex;\n      flex-direction: row;\n      gap: 2em;\n      flex-wrap: nowrap;\n    }\n\n    #f, #o {\n      bottom: 20%;\n    }\n  }\n\n  @include screen-xl {\n    .footer {\n      height: 10em;\n      padding: 7em;\n      align-items: center;\n\n      &_logo {\n        flex: 2;\n      }\n    }\n\n    .footer_nav-links {\n      display: flex;\n      flex-direction: row;\n      gap: 2em;\n      flex-wrap: nowrap;\n    }\n\n    #f, #o {\n      bottom: 8%;\n    }\n  }\n","$bdt-yellow-gold: #ffe100;\n$bdt-gold: #ffc917;\n$bdt-red: #f00000;\n$bdt-dark-red: #8c0000;\n$bdt-black: #050505;\n$bdt-gray: #88888a;\n$bdt-white: #f3f3f3;\n$bdt-green: #37ff8b;\n\n","$screen-sm: 390px;\n$screen-md: 768px;\n$screen-lg: 1024px;\n$screen-xl: 1280px;\n$screen-2xl: 1640px;\n$screen-3xl: 1920px;\n\n@mixin screen-sm {\n  @media (min-width: $screen-sm) {\n    @content;\n  }\n}\n\n@mixin screen-md {\n  @media (min-width: $screen-md) {\n    @content;\n  }\n}\n\n@mixin screen-lg {\n  @media (min-width: $screen-lg) {\n    @content;\n  }\n}\n\n@mixin screen-xl {\n  @media (min-width: $screen-xl) {\n    @content;\n  }\n}\n\n@mixin screen-2xl {\n  @media (min-width: $screen-2xl) {\n    @content;\n  }\n}\n\n@mixin screen-3xl {\n  @media (min-width: $screen-3xl) {\n    @content;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
